module.exports = __webpack_public_path__ + "static/media/tinyUser.48941886.svg";